import React, { useEffect, useState } from 'react'
import { Modal } from 'components'

import styles from './styles.module.css'
import { AppUpdateSvg, ShineLogoFa } from 'assets/images'
import Button from 'components/Button'

const UpdateAppModal = ({ isOpen, setIsOpen, onUpdate }) => {
  return (
    <Modal isOpen={isOpen} setIsOpen={setIsOpen} zIndex={21}>
      <div className={styles.content}>
        <div className="d-flex align-items-center">
          <img src={ShineLogoFa} width="70px" />
          <h4 className={styles.title}>نسخه جدید</h4>
        </div>
        <p className={styles.desc}>
          برای بهبود عملکرد اپلیکیشن پگاه بروزرسانی کنید.
        </p>
        <img src={AppUpdateSvg} className="w-75" />
        <div className="w-100" style={{ margin: '20px 0 10px 0' }}>
          <Button className="w-100" type={'primary'} onClick={() => onUpdate()}>
            بروزرسانی
          </Button>
        </div>
        <Button className="w-100" ghost={true} onClick={() => setIsOpen(false)}>
          بعدا
        </Button>
      </div>
    </Modal>
  )
}

export default UpdateAppModal
